import React, { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { debounce } from 'lodash';
import { validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import { updateQueryFilterJoin } from '../actions';
import { fetchClauseCounts } from '../../profile/actions';
import { refreshCohortVisualisation } from '../../visualisations/actions';
import { findQueryFilter } from '../../state/shared';
import { isFilterField } from '../../helper';

const listItems = (dictionary, fieldType) => (
  dictionary.fields.filter((f) => f.type === fieldType && isFilterField(f)).map((item) => ({
    key: `cohort_join_item_${dictionary.code}_${item.name}`,
    text: item.label,
    value: `${dictionary.code}#${item.name}`,
    description: dictionary.name,
  }))
);

const CohortFilterJoinsDropdown = ({
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  fieldType,
  dictionaryCode,
  fieldName,
  dictionaries,
  disabled,
  updateJoin,
  fetchCounts,
  fetchVisualisation,
  saveErrors,
}) => {
  const intl = useIntl();
  const refreshCounts = useMemo(() => debounce(fetchCounts, 500), []);
  const refreshVisualisation = useMemo(() => debounce(fetchVisualisation, 700), []);

  const updateFilterJoin = (dictionaryField) => {
    const [newCode, name] = dictionaryField.split('#');
    updateJoin(category, code, queryUUID, clauseUUID, filterUUID, newCode, name);
    refreshCounts(category, code, queryUUID, clauseUUID, true);
    refreshVisualisation(category, code, queryUUID);
  };

  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.JOIN)));

  return (
    <Dropdown
      fluid
      search
      selection
      className={validationClasses(validationError, 'aridhia-cohort-filter-joins-dropdown max-content')}
      value={`${dictionaryCode}#${fieldName}`}
      options={dictionaries.map((d) => listItems(d, fieldType)).flat()}
      disabled={disabled}
      placeholder={intl.formatMessage({ id: 'cohort.filter.join.placeholder' })}
      noResultsMessage={intl.formatMessage({ id: 'cohort.filter.no.joins' })}
      onChange={(e, { value }) => { updateFilterJoin(value); }}
    />
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { query, filter } = findQueryFilter(cohorts, ownProps);
  const dictionaries = query.dataset.dictionaries.filter((r) => (r.code !== ownProps.dictionaryCode));

  return (
    {
      dictionaryCode: filter.join?.dictionary?.code,
      fieldName: filter.join?.name,
      fieldType: filter.field?.type,
      dictionaries,
    }
  );
};

export const mapDispatchToProps = {
  updateJoin: updateQueryFilterJoin,
  fetchCounts: fetchClauseCounts,
  fetchVisualisation: refreshCohortVisualisation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortFilterJoinsDropdown);
